import { api } from "./api";

const VISITOR_KEY = "clinq_visitor_id";
const IDENTIFIED_KEY = "clinq_visitor_identified"; // `${visitorId}:${userId}`

export function getVisitorId() {
  let id = localStorage.getItem(VISITOR_KEY);
  if (!id) {
    id = (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}-${Math.random().toString(36).slice(2)}`)
      .replace(/[^A-Za-z0-9_-]/g, "").slice(0, 64);
    localStorage.setItem(VISITOR_KEY, id);
  }
  return id;
}

let _lastPath = "";
let _lastAt = 0;

/** Fire-and-forget page view log — must never disturb the UI. */
export function trackPageView(path) {
  try {
    // Guard against double-fires (React StrictMode dev remounts, rapid
    // re-renders): ignore the same path within 800ms.
    const now = Date.now();
    if (path === _lastPath && now - _lastAt < 800) return;
    _lastPath = path; _lastAt = now;
    api.post("/track/pageview", {
      visitor_id: getVisitorId(),
      path,
      referrer: document.referrer || "",
    }).catch(() => {});
  } catch (_) { /* ignore */ }
}

/** Stitch anonymous history onto the user — once per (visitor, user) pair. */
export function identifyVisitor(userId) {
  try {
    const visitorId = getVisitorId();
    const stamp = `${visitorId}:${userId}`;
    if (localStorage.getItem(IDENTIFIED_KEY) === stamp) return;
    api.post("/track/identify", { visitor_id: visitorId })
      .then(() => localStorage.setItem(IDENTIFIED_KEY, stamp))
      .catch(() => {});
  } catch (_) { /* ignore */ }
}
